import type { ReactNode } from "react";
import { cn } from "@/lib/utils";
import { SiteHeader, SiteFooter } from "@/components/layout/SiteShell";

/**
 * Mobile-first viewport wrapped in full-width site chrome (header + footer).
 * Used by participant pre-event flow.
 */
export function MobileFrame({ children, className }: { children: ReactNode; className?: string }) {
  return (
    <div className={cn("flex min-h-screen w-full flex-col bg-[#fafafa]", className)}>
      <SiteHeader />
      <div className="flex flex-1 w-full justify-center">
        <div className="flex w-full max-w-[440px] flex-col bg-[#fafafa]">{children}</div>
      </div>
      <SiteFooter />
    </div>
  );
}
